import { render, staticRenderFns } from "./TransitionDialog.vue?vue&type=template&id=64ba624c&"
import script from "./TransitionDialog.vue?vue&type=script&lang=ts&"
export * from "./TransitionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports